import React from 'react';

const KEYS = [
  ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
  ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
  ['ENTER', 'Z', 'X', 'C', 'V', 'B', 'N', 'M', '⌫'],
];

const Keyboard = ({ onKeyPress, usedLetters, disabled = false, isSubmitting = false }) => {
  const getKeyClass = (key) => {
    if (usedLetters.has(`${key}-correct`)) return 'correct';
    if (usedLetters.has(`${key}-present`)) return 'present';
    if (usedLetters.has(`${key}-absent`)) return 'absent';
    return '';
  };

  return (
    <div className="keyboard">
      {KEYS.map((row, i) => (
        <div key={i} className="keyboard-row">
          {row.map((key) => {
            const isEnterLoading = key === 'ENTER' && isSubmitting;
            return (
              <button
                key={key}
                onClick={() => onKeyPress(key)}
                data-key={key}
                aria-label={isEnterLoading ? 'Submitting guess' : key}
                disabled={disabled}
                className={`keyboard-key ${getKeyClass(key)}${isEnterLoading ? ' keyboard-key--loading' : ''}`}
              >
                {isEnterLoading ? <span className="keyboard-key__spinner" aria-hidden="true" /> : key}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default Keyboard; 